import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import { arrayOf, bool, func, number, object, oneOf } from 'prop-types';
import { SIZE } from "./constants";
export var paginationPropTypes = {
  currentPage: number.isRequired,
  messages: object,
  // TODO: improve using shape
  onPageChange: func.isRequired,
  onPageSizeChange: func,
  pageSize: number.isRequired,
  pageSizes: arrayOf(number),
  showPageJumper: bool,
  showPageNumbers: bool,
  showPageSizer: bool,
  size: oneOf(Object.keys(SIZE)),
  totalCount: number.isRequired,
  visibleRange: number
};